module.exports = __webpack_public_path__ + "img/kitchen_room.be5030ca.webp";